import { v4 as uuidv4 } from 'uuid';

const CORS_PROXY = 'https://corsproxy.io/?';
const OPENFOODFACTS_API = 'https://world.openfoodfacts.org/cgi/search.pl';

// Erweiterte lokale Map für bessere Offline-Klassifizierung
const LOCAL_CATEGORY_MAP = {
  // Obst & Gemüse
  'apfel': 'Obst & Gemüse', 'banane': 'Obst & Gemüse', 'traube': 'Obst & Gemüse',
  'karotte': 'Obst & Gemüse', 'salat': 'Obst & Gemüse', 'paprika': 'Obst & Gemüse',
  'gurke': 'Obst & Gemüse', 'tomate': 'Obst & Gemüse', 'zwiebel': 'Obst & Gemüse',
  'kartoffel': 'Obst & Gemüse', 'knoblauch': 'Obst & Gemüse', 'zucchini': 'Obst & Gemüse',
  'brokkoli': 'Obst & Gemüse', 'spinat': 'Obst & Gemüse', 'pilz': 'Obst & Gemüse',
  'champignon': 'Obst & Gemüse', 'lauch': 'Obst & Gemüse', 'kohl': 'Obst & Gemüse',
  'blumenkohl': 'Obst & Gemüse', 'beere': 'Obst & Gemüse', 'birne': 'Obst & Gemüse',
  'avocado': 'Obst & Gemüse', 'ingwer': 'Obst & Gemüse', 'kräuter': 'Obst & Gemüse',
  'petersilie': 'Obst & Gemüse', 'basilikum': 'Obst & Gemüse', 'schnittlauch': 'Obst & Gemüse',
  'kürbis': 'Obst & Gemüse', 'aubergine': 'Obst & Gemüse', 'radieschen': 'Obst & Gemüse',
  
  // Milch & Käse
  'milch': 'Milch & Käse', 'käse': 'Milch & Käse', 'joghurt': 'Milch & Käse',
  'butter': 'Milch & Käse', 'sahne': 'Milch & Käse', 'quark': 'Milch & Käse',
  'mozzarella': 'Milch & Käse', 'ei': 'Milch & Käse', 'eier': 'Milch & Käse',
  'schmand': 'Milch & Käse', 'creme fraiche': 'Milch & Käse', 'feta': 'Milch & Käse',
  'parmesan': 'Milch & Käse', 'gouda': 'Milch & Käse', 'emmentaler': 'Milch & Käse',
  'buttermilch': 'Milch & Käse', 'kefir': 'Milch & Käse', 'mascarpone': 'Milch & Käse',
  
  // Fleisch & Fisch
  'fleisch': 'Fleisch & Fisch', 'hähnchen': 'Fleisch & Fisch', 'rind': 'Fleisch & Fisch',
  'fisch': 'Fleisch & Fisch', 'lachs': 'Fleisch & Fisch', 'thunfisch': 'Fleisch & Fisch',
  'wurst': 'Fleisch & Fisch', 'schinken': 'Fleisch & Fisch', 'salami': 'Fleisch & Fisch',
  'hack': 'Fleisch & Fisch', 'speck': 'Fleisch & Fisch', 'schnitzel': 'Fleisch & Fisch',
  'steak': 'Fleisch & Fisch', 'bratwurst': 'Fleisch & Fisch', 'pute': 'Fleisch & Fisch',
  'garnele': 'Fleisch & Fisch', 'forelle': 'Fleisch & Fisch', 'filet': 'Fleisch & Fisch',
  
  // Brot & Gebäck
  'brot': 'Brot & Gebäck', 'brötchen': 'Brot & Gebäck', 'toast': 'Brot & Gebäck',
  'baguette': 'Brot & Gebäck', 'croissant': 'Brot & Gebäck', 'semmel': 'Brot & Gebäck',
  'brezel': 'Brot & Gebäck', 'kuchen': 'Brot & Gebäck', 'teig': 'Brot & Gebäck',
  'mehl': 'Brot & Gebäck', 'hefe': 'Brot & Gebäck', 'backpulver': 'Brot & Gebäck',
  
  // Vorrat / Nudeln / Gewürze
  'nudel': 'Vorrat & Gewürze', 'pasta': 'Vorrat & Gewürze', 'spaghetti': 'Vorrat & Gewürze',
  'reis': 'Vorrat & Gewürze', 'zucker': 'Vorrat & Gewürze', 'salz': 'Vorrat & Gewürze', 
  'pfeffer': 'Vorrat & Gewürze', 'öl': 'Vorrat & Gewürze', 'essig': 'Vorrat & Gewürze', 
  'konserve': 'Vorrat & Gewürze', 'dose': 'Vorrat & Gewürze', 'soße': 'Vorrat & Gewürze', 
  'ketchup': 'Vorrat & Gewürze', 'senf': 'Vorrat & Gewürze', 'mayo': 'Vorrat & Gewürze',
  'brühe': 'Vorrat & Gewürze', 'gewürz': 'Vorrat & Gewürze', 'marmelade': 'Vorrat & Gewürze',
  'honig': 'Vorrat & Gewürze', 'müsli': 'Vorrat & Gewürze', 'haferflocken': 'Vorrat & Gewürze',
  'cornflakes': 'Vorrat & Gewürze', 'linse': 'Vorrat & Gewürze', 'bohne': 'Vorrat & Gewürze',
  
  // Getränke
  'wasser': 'Getränke', 'saft': 'Getränke', 'cola': 'Getränke', 'limo': 'Getränke', 
  'bier': 'Getränke', 'wein': 'Getränke', 'kaffee': 'Getränke', 'tee': 'Getränke',
  'sprudel': 'Getränke', 'sekt': 'Getränke', 'sirup': 'Getränke',
  
  // Snacks
  'schokolade': 'Snacks & Süßes', 'chips': 'Snacks & Süßes', 'keks': 'Snacks & Süßes',
  'nuss': 'Snacks & Süßes', 'gummibär': 'Snacks & Süßes', 'riegel': 'Snacks & Süßes',
  'bonbon': 'Snacks & Süßes', 'salzstangen': 'Snacks & Süßes', 'popcorn': 'Snacks & Süßes',
  
  // Kühl & Tiefkühl
  'pizza': 'Kühl & Tiefkühl', 'eis': 'Kühl & Tiefkühl', 'tk': 'Kühl & Tiefkühl',
  'pommes': 'Kühl & Tiefkühl', 'gefroren': 'Kühl & Tiefkühl', 'stäbchen': 'Kühl & Tiefkühl',
  
  // Haushalt & Drogerie
  'papier': 'Haushalt & Drogerie', 'reiniger': 'Haushalt & Drogerie', 'seife': 'Haushalt & Drogerie',
  'shampoo': 'Haushalt & Drogerie', 'waschmittel': 'Haushalt & Drogerie', 'spülmittel': 'Haushalt & Drogerie',
  'zahnpasta': 'Haushalt & Drogerie', 'duschgel': 'Haushalt & Drogerie', 'creme': 'Haushalt & Drogerie',
  'windel': 'Haushalt & Drogerie', 'tuch': 'Haushalt & Drogerie', 'schwamm': 'Haushalt & Drogerie',
  'beutel': 'Haushalt & Drogerie', 'folie': 'Haushalt & Drogerie'
};

const CATEGORY_MAPPING = {
  'en:plant-based-foods-and-beverages': 'Obst & Gemüse',
  'en:fruits-and-vegetables-based-foods': 'Obst & Gemüse',
  'en:fresh-foods': 'Obst & Gemüse',
  'en:dairies': 'Milch & Käse',
  'en:cheeses': 'Milch & Käse',
  'en:milks': 'Milch & Käse',
  'en:meats': 'Fleisch & Fisch',
  'en:seafood': 'Fleisch & Fisch',
  'en:fishes': 'Fleisch & Fisch',
  'en:beverages': 'Getränke',
  'en:snacks': 'Snacks & Süßes',
  'en:sweet-snacks': 'Snacks & Süßes',
  'en:salty-snacks': 'Snacks & Süßes',
  'en:frozen-foods': 'Kühl & Tiefkühl',
  'en:cereals-and-potatoes': 'Vorrat & Gewürze',
  'en:breads': 'Brot & Gebäck',
  'en:hygiene': 'Haushalt & Drogerie',
  'en:household': 'Haushalt & Drogerie'
};

export const productService = {
  async categorize(itemName) {
    if (!itemName) return 'Sonstiges';
    const lowerName = itemName.toLowerCase().trim();

    // 1. Lokale Map (Teilwortsuche)
    for (const [key, cat] of Object.entries(LOCAL_CATEGORY_MAP)) {
      if (lowerName.includes(key)) return cat;
    }

    // 2. OpenFoodFacts API (nur wenn lokal nichts gefunden)
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 1000); // Schneller Timeout

      const searchUrl = `${OPENFOODFACTS_API}?search_terms=${encodeURIComponent(lowerName)}&search_simple=1&action=process&json=1&page_size=1`;
      const proxyUrl = `${CORS_PROXY}${encodeURIComponent(searchUrl)}`;
      
      const response = await fetch(proxyUrl, { signal: controller.signal });
      clearTimeout(timeoutId);

      if (response.ok) {
        const data = await response.json();
        if (data.products && data.products.length > 0) {
          const product = data.products[0];
          if (product.categories_tags) {
            for (const tag of product.categories_tags) {
              if (CATEGORY_MAPPING[tag]) return CATEGORY_MAPPING[tag];
              if (tag.includes('vegetable') || tag.includes('fruit')) return 'Obst & Gemüse';
              if (tag.includes('meat') || tag.includes('poultry')) return 'Fleisch & Fisch';
              if (tag.includes('dairy') || tag.includes('cheese')) return 'Milch & Käse';
              if (tag.includes('bread')) return 'Brot & Gebäck';
              if (tag.includes('beverage') || tag.includes('drink')) return 'Getränke';
              if (tag.includes('frozen')) return 'Kühl & Tiefkühl';
            }
          }
        }
      }
    } catch (error) {
      // Ignorieren
    }

    return 'Sonstiges';
  }
};